// import React from 'react';

// const CopyDialog = () => {
//     return (
//         <div>

//         </div>
//     );
// };

// export default CopyDialog;

import React, { useEffect, useState } from "react";
import SweetAlertModal from "../../../components/SweetAlertModal/SweetAlertModal";
import Cancel from "./../../../../assets/icons/close.png";
import itemImg from "./../../../../assets/icons/menu.png";
import CustomDataGrid from "../../../components/CustomDataGrid/CustomDataGrid.tsx";
import { ToastContainer, toast } from "react-toastify";
import Typography from "@mui/material/Typography";
import AutoCompleteMultiSelect from "../../../../pages/components/AutoCompleteMultiselect/AutoCompleteMultiSelect.tsx";
import { styled } from "@mui/material/styles";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
//import "./ArchiveDialog.css";

import axios from "axios";

import {
  Button,
  Grid,
  Switch,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  tooltipClasses,
  Tooltip,
} from "@mui/material";

function CopyDialog(props) {
  console.log(props);

  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [openMenuCloseConfirmaitonModal, setopenMenuCloseConfirmaitonModal] =
    useState(false);
  const [openArchiveConfirmaitonModal, setopenArchiveConfirmaitonModal] =
    useState(false);
  const [selectedValue, setSelectedValue] = useState<any>(null);
  const [dataRows, setDataRows] = useState([]);

  const [selectedDataRows, setSelectedDatarows] = React.useState([]);
  const [valueAdded, setValueAdded] = useState([]);
  const getselectedData = (props) => {
    console.log(props);
    setSelectedDatarows(props);
  };

  const typrOfMenuDatas = [
    { id: 2, title: "Online" },
    { id: 3, title: "Whole sales" },
    { id: 4, title: "Corporate " },
    { id: 4, title: "Instore " },
  ];

  const handleClose = () => {
    props.onClose();
    // setKeyword(null)
    setSelectedValue(null);
    setopenMenuCloseConfirmaitonModal(false);
    setopenArchiveConfirmaitonModal(false);
    setOpenDialog(false);
    setRestaurantId([]);
    setswitchCheck(false)
    setswitchCheck2nd(false)
  };
  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedRowId(null);
  };

  const {
    open,
    onClose,
    dialogType, //
    id,
    cancledRes, // linked menus
    onToggleSwitch,
    selectedRestaurants,
    openDialog: toggle,
    restaurantAdded,
    addedNewMenu // present restaurent
  } = props;

  console.log(addedNewMenu);

  const apiAddress = process.env.REACT_APP_SECRET;

  const [restaurantId, setRestaurantId] = useState([]);

  useEffect(() => {
    console.log(addedNewMenu);
  }, [addedNewMenu]);
  // if (restaurantAdded) {
  //   cancledRes.push(restaurantAdded);
  // }
  const [sectionSelected, setsectionSelected] = useState([]);
  const [copySectionId, setcopySectionId] = useState([]);

  const sectionAddedvalue = (props) => {
    
    setsectionSelected(props);
  };

  const copySubmit = () => {

    if (sectionSelected) {
      var obj = [];



      sectionSelected.map((dt, i) => {
        console.log(dt.id)
        if(copySectionId.find(x=>x==dt.id)==undefined){       
          copySectionId.push(dt.id);
          
        }
        console.log(copySectionId)
        
      });
      console.log(copySectionId)

      obj=copySectionId;
      
      console.log(obj[0])

      console.log(addedNewMenu[0].id)

      axios
      .post(apiAddress + '/api/Section/CopySection_PostNewSection?id='+obj[0]+
        '&restaurantId='+addedNewMenu[0].linkedRestaurantId+
        '&menuId='+addedNewMenu[0]?.id+
        '&kitchenId='+KitchenSelected[0]?.id+
        '&activeSectionId='+ addedNewMenu[0]?.activeSection +
        '&islink='+switchCheck+
        '&islinkall='+switchCheck2nd
      )
        
        .then((response) => {
          console.log(response.data);
          toast.success("Menu Succesfully Copied", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
        props.onHandleAddItem();
         setopenMenuCloseConfirmaitonModal(false);
         setopenArchiveConfirmaitonModal(false);
         setOpenDialog(false);

    });
  }
}

const [KitchenSelected, setKitchenSelected] = useState([]);
const [kitchenDatas, setkitchenDatas] = useState([]);

const kitchenAddedvalue = (props) => {
  console.log(props);
  setKitchenSelected(props);
};

useEffect(() => {
  LoadKitchenData()
  console.log(addedNewMenu)
}, [addedNewMenu]);

const LoadKitchenData = () => {
  if(addedNewMenu.length>0){
  axios
    .get(apiAddress + '/api/Kitchen/GetKitchenListByResId?Id='+ addedNewMenu[0].linkedRestaurantId)
    .then((response) => {
      var list = [];
      response.data.map((dt, i) => {
        var obj = {
          id: dt.id,
          title: dt.name,
        };
        list.push(obj);
      });
      console.log(list);
      setkitchenDatas(list);
      //loadEditRestaurant(list);
    });
  }
}

const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 320,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9",
  },
}));

const [switchCheck, setswitchCheck] = useState(false);
const [switchCheck2nd, setswitchCheck2nd] = useState(false);

const handleSwitchChange = () => {
  setswitchCheck(!switchCheck);
};
const handleSwitch2ndChange = () => {
  setswitchCheck2nd(!switchCheck2nd);
};

  return (
    <div>
      <React.Fragment>
        <Dialog
          maxWidth={"md"}
          fullWidth={true}
          open={props.open}
          onClose={handleClose}
        >
          <SweetAlertModal
            headerText={"Do you want to leave without saving?"}
            bodyText={"All changes made will be lost"}
            open={openMenuCloseConfirmaitonModal}
            onyes={handleClose}
            close={() => {
              setopenMenuCloseConfirmaitonModal(false);
            }}
            id={2}
          />

          <SweetAlertModal
            headerText={"Are you sure?"}
            bodyText={"All changes made will be lost"}
            open={openArchiveConfirmaitonModal}
            onyes={copySubmit}
            close={() => {
              setopenArchiveConfirmaitonModal(false);
            }}
          />
          <Grid container>
            <Grid item xs={6}>
              <DialogTitle>
                <div className="d-flex" style={{ gap: "8px" }}>
                  <div>
                    <img src={itemImg} style={{ width: "1.8rem" }} alt="" />
                  </div>

                  <span style={{ color: "#2a7fd4" }}>
                    GoTaste :- {dialogType}
                  </span>
                </div>
              </DialogTitle>
            </Grid>
            <Grid item xs={6}>
              <DialogActions>
                <Button onClick={() => setopenMenuCloseConfirmaitonModal(true)}>
                  <img src={Cancel} alt="Close" style={{ width: "1.2rem" }} />
                </Button>
              </DialogActions>
            </Grid>
          </Grid>
          <DialogContent style={{ backgroundColor: "#f3f0f3" }}>
            <div>
              <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={1}>
                  <Typography style={{ paddingTop: "2rem" }}>Section</Typography>
                </Grid>
                <Grid item xs={11} style={{ paddingTop: "1rem" }}>
                  <AutoCompleteMultiSelect
                    id={2}
                    placeholder={"Select a section"}
                    datas={cancledRes}
                    value={sectionAddedvalue}
                    val={sectionSelected}
                  />
                </Grid>
              </Grid>
            </div>
            <div>
              <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={1}>
                  <Typography style={{ paddingTop: "2rem" }}>Kitchen</Typography>
                </Grid>
                <Grid item xs={11} style={{ paddingTop: "1rem" }}>
                  <AutoCompleteMultiSelect
                    id={2}
                    placeholder={"Select a Kitchen"}
                    datas={kitchenDatas}
                    value={kitchenAddedvalue}
                    val={KitchenSelected}
                  />
                </Grid>
              </Grid>
            </div>

            <div>
            <Grid container sx={{ padding: "0.5rem" }}>
            <Grid item xs={2}>
                <div
                  className="d-flex"
                  style={{ paddingTop: "1rem", gap: "10px" }}
                >
                  <Typography>Apply Linkage</Typography>
                  <HtmlTooltip
                    title={
                      <React.Fragment>
                        <Typography color="inherit">
                          This option allow you to link newly created section with other sections within the list. 
                        </Typography>
                      </React.Fragment>
                    }
                  >
                    <InfoOutlinedIcon style={{ color: "#371B17" }} />
                  </HtmlTooltip>
                </div>
              </Grid>
              <Grid item xs={9} sx={{ padding: "0.5rem" }}>
                <Switch
                  checked={switchCheck}
                  onChange={handleSwitchChange}
                  inputProps={{ "aria-label": "controlled" }}
                />
              </Grid>
            </Grid>

            {switchCheck && (
              <Grid container sx={{ padding: "0.5rem" }}>
              <Grid item xs={2}>
                <div
                  className="d-flex"
                  style={{ paddingTop: "1rem", gap: "10px" }}
                >
                  <Typography>Apply Linkage to all Sections linked with Active Section</Typography>
                  <HtmlTooltip
                    title={
                      <React.Fragment>
                        <Typography color="inherit">
                        "Toggle On" will link the newly created section with the active section as well as any linked section that are associated with the active section. 
                        "Toggle Off" will only link the newly created section to the menu selected section.
                        </Typography>
                      </React.Fragment>
                    }
                  >
                    <InfoOutlinedIcon style={{ color: "#371B17" }} />
                  </HtmlTooltip>
                </div>
              </Grid>
              <Grid item xs={9} sx={{ padding: "0.5rem" }} >
                <Switch
                  checked={switchCheck2nd}
                  onChange={handleSwitch2ndChange}
                  inputProps={{ "aria-label": "controlled" }}
                />
              </Grid>
            </Grid>
            )}
            </div>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setopenArchiveConfirmaitonModal(true)}
              color="error"
            >
              Copy
            </Button>
            <Button
              onClick={() => {setopenMenuCloseConfirmaitonModal(true)}}
              color="primary"
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    </div>
  );
}

export default CopyDialog;
